import { useTransition } from "react";
import { useSelector } from "react-redux";
import useMovieTrailer from "../hooks/useMovieTrailer";

const VideoBackground = ({movieId}) => {
     //Fetch my trailer and updating store with trailer video data
     useMovieTrailer(movieId);
     const trailerVideo = useSelector(store => store.movies?.trailerVideo);
  return (
    <div className="w-screen">
      <iframe className="w-screen aspect-video"
       src={"https://www.youtube.com/embed/"+trailerVideo?.key+"?rel=0?version=3&autoplay=1&mute=1&controls=0&&showinfo=0&loop=1"} title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
    </div>
  )
}

export default VideoBackground
